function $27f33e380669b1e3$var$randomDelay() {
    return Math.floor(Math.random() * 4000 + 1000);
}
function $27f33e380669b1e3$var$delayPromise(text, delay) {
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            resolve(text);
        }, delay);
    });
}
const $27f33e380669b1e3$var$delay1 = $27f33e380669b1e3$var$randomDelay();
const $27f33e380669b1e3$var$delay2 = $27f33e380669b1e3$var$randomDelay();
const $27f33e380669b1e3$var$delay3 = $27f33e380669b1e3$var$randomDelay();
const $27f33e380669b1e3$var$delay4 = $27f33e380669b1e3$var$randomDelay();
const $27f33e380669b1e3$var$delay5 = $27f33e380669b1e3$var$randomDelay();
const $27f33e380669b1e3$var$promise1 = $27f33e380669b1e3$var$delayPromise(`Promise made with delay ${$27f33e380669b1e3$var$delay1}`, $27f33e380669b1e3$var$delay1);
const $27f33e380669b1e3$var$promise2 = $27f33e380669b1e3$var$delayPromise(`Promise made with delay ${$27f33e380669b1e3$var$delay2}`, $27f33e380669b1e3$var$delay2);
const $27f33e380669b1e3$var$promise3 = $27f33e380669b1e3$var$delayPromise(`Promise made with delay ${$27f33e380669b1e3$var$delay3}`, $27f33e380669b1e3$var$delay3);
const $27f33e380669b1e3$var$promise4 = $27f33e380669b1e3$var$delayPromise(`Promise made with delay ${$27f33e380669b1e3$var$delay4}`, $27f33e380669b1e3$var$delay4);
const $27f33e380669b1e3$var$promise5 = $27f33e380669b1e3$var$delayPromise(`Promise made with delay ${$27f33e380669b1e3$var$delay5}`, $27f33e380669b1e3$var$delay5);
Promise.all([
    $27f33e380669b1e3$var$promise1,
    $27f33e380669b1e3$var$promise2,
    $27f33e380669b1e3$var$promise3,
    $27f33e380669b1e3$var$promise4,
    $27f33e380669b1e3$var$promise5
]).then((res)=>console.log(res));
Promise.race([
    $27f33e380669b1e3$var$promise1,
    $27f33e380669b1e3$var$promise2,
    $27f33e380669b1e3$var$promise3,
    $27f33e380669b1e3$var$promise4,
    $27f33e380669b1e3$var$promise5
]).then((res)=>console.log(res));


const $ef2ab4351c5690cc$var$randomDelay = (value)=>{
    return new Promise((resolve)=>{
        const delay = Math.floor(Math.random() * 4001 + 1000);
        setTimeout(()=>{
            resolve(value);
        }, delay);
    });
};
const $ef2ab4351c5690cc$var$promises = [
    $ef2ab4351c5690cc$var$randomDelay("A"),
    $ef2ab4351c5690cc$var$randomDelay("B"),
    $ef2ab4351c5690cc$var$randomDelay("C"),
    $ef2ab4351c5690cc$var$randomDelay("D"),
    $ef2ab4351c5690cc$var$randomDelay("E")
];
Promise.race($ef2ab4351c5690cc$var$promises).then((result)=>{
    console.log("Fastest:", result);
});




//# sourceMappingURL=14hw.ca9509fd.js.map
